// src/components/LatestBlogPreview.js

import React from "react";
import Slider from "react-slick";
import {
  Box,
  Typography,
  Button,
  CircularProgress,
  Alert,
} from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import BlogPostCard from "./BlogPostCard";
import { API_BASE } from "../lib/api";

// Ύψος κάρτας ΜΟΝΟ για το Dashboard (ταιριάζει με Recommender)
const DASHBOARD_CARD_HEIGHT = 356;

export default function LatestBlogPreview({
  limit = 3,
  showHeader = true,
  cardHeight = DASHBOARD_CARD_HEIGHT,
}) {
  const [posts, setPosts] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    fetch(`${API_BASE}/blog/posts/?page_size=${limit}`)
      .then((res) => res.json())
      .then((data) => setPosts(data.results || []))
      .catch(() => setError("Could not load posts."))
      .finally(() => setLoading(false));
  }, [limit]);

  const settings = {
    dots: true,
    arrows: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 4000,
    speed: 600,
    slidesToShow: 1,
    slidesToScroll: 1,
    adaptiveHeight: false, // δεν χρειάζεται να αλλάζει, έχουμε σταθερό card height
  };

  return (
    <Box sx={{ width: "100%" }}>
      {/* Header */}
      {showHeader && (
        <Box
          sx={{
            mb: 2,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography component="h2" variant="h6">
            Latest from the INNOVakis Blog
          </Typography>
          <Button size="small" component={RouterLink} to="/blog">
            View all
          </Button>
        </Box>
      )}

      {/* Loading */}
      {loading && (
        <Box sx={{ textAlign: "center", py: 4 }}>
          <CircularProgress />
        </Box>
      )}

      {/* Error */}
      {error && <Alert severity="error">{error}</Alert>}

      {/* Slider */}
      {!loading && !error && posts.length > 0 && (
        <Slider {...settings}>
          {posts.map((post) => (
            <Box key={post.id} sx={{ px: 1 }}>
              {/* ⭐ Εδώ κλειδώνουμε το ύψος ΜΟΝΟ για το Dashboard */}
              <BlogPostCard post={post} fixedHeight={cardHeight} />
            </Box>
          ))}
        </Slider>
      )}
    </Box>
  );
}
